module.exports = __webpack_public_path__ + "img/ico-checklist-round.c2d92529.svg";